import { ActionType, InitializationReason } from '@banking/ui/workflows/card-settings/billing-address';
import { filter, map } from 'rxjs/operators';
import { EventLogging } from '@banking/ui/workflows/card-settings/analytics/analytics';
export let Target = /*#__PURE__*/function (Target) {
  Target["WrongAddress"] = "Wrong Address";
  return Target;
}({});
export let SubFeature = /*#__PURE__*/function (SubFeature) {
  SubFeature["ConfirmReplacementCardShippingAddress"] = "Confirm Replacement Card Shipping Address";
  return SubFeature;
}({});
const confirmReplacementCardAddressView = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.Initialize && action.reason === InitializationReason.OPEN_CONFIRM_REPLACEMENT_CARD_ADDRESS_POPUP), map(([[_before, after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.View,
  subFeature: SubFeature.ConfirmReplacementCardShippingAddress,
  unitToken: after.unitToken
})));
const wrongAddressClick = updates => updates.pipe(filter(([_, action]) => action.type === ActionType.Initialize && action.reason === InitializationReason.CLICK_WRONG_REPLACEMENT_CARD_ADDRESS), map(([[_before, after], _]) => EventLogging.CDP.event({
  action: EventLogging.Action.Click,
  target: Target.WrongAddress,
  unitToken: after.unitToken
})));
export default [confirmReplacementCardAddressView, wrongAddressClick];